import { render, staticRenderFns } from "./ClinicalIntake.vue?vue&type=template&id=412f8672"
import script from "./ClinicalIntake.vue?vue&type=script&lang=js"
export * from "./ClinicalIntake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports